import(/* webpackMode: "eager" */ "/codebuild/output/src1796548407/src/ui-directo/apps/customer/src/app/(loginLayout)/login/page.tsx");
